export const shouldShowMarcaBlancaModal = (
  clientId: number | null | undefined,
  marcaBlancaId: number | undefined
): boolean => {
  if (marcaBlancaId === undefined || clientId === null || clientId === undefined) {
    return false;
  }
  return Number(clientId) === Number(marcaBlancaId);
};
